import { ExceptionEventComment } from "@fairfleet/geotab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { format } from "date-fns";
import { useUserById } from "@/hooks/users/useUserById";

interface EventCommentProps {
  comment: ExceptionEventComment;
}

export default function EventComment({ comment }: EventCommentProps) {
  const { id, text, dateTime, user } = comment;
  const { data: userData } = useUserById(user.id);

  const formattedDate = dateTime ? format(new Date(dateTime), "dd.MM.yyyy HH:mm") : "";

  return (
    <Box
      key={id}
      sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 1 }}
    >
      <Box>
        <Typography variant="body1">{text}</Typography>
        <Typography variant="caption" color="text.secondary">
          {userData?.name || "Unknown User"} - {formattedDate}
        </Typography>
      </Box>
    </Box>
  );
}
